import React from 'react';

class Repository extends React.Component{
    constructor(props){
        super(props);
        this.state = {

        }
    }

    render(){
        return(
            <div>这里是资源库页面</div>
        )
    }
}

export default Repository